// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.beta.ts`.
// The list of file replacements can be found in `angular.json`.

import { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';
import { KeycloakOptions } from 'keycloak-angular';


// export const appUrl = 'http://localhost:8080';
export const appUrl = 'https://posf-staging.anre.ro';
// export const appUrl = 'https://posf-dev.anre.ro';
// export const devAppUrl = 'https://posf-dev.anre.ro';
export const devAppUrl = 'https://posf-staging.anre.ro';

const keycloakConfig: KeycloakConfig = {
  url: 'https://posf-staging.anre.ro/auth/',
  realm: 'Anre',
  clientId: 'anre-back-office-web-app',
};

const keycloakInitOptions: KeycloakInitOptions = {
  onLoad: 'check-sso',
  checkLoginIframe: false,
};

export const keycloakOptions: KeycloakOptions = {
  config: keycloakConfig,
  initOptions: keycloakInitOptions,
  enableBearerInterceptor: true,
};

export const environment = {
  feUrl: 'https://posf-staging.anre.ro/',
  production: false,
  baseUrl: appUrl + '/api/v1',
  comparatorBaseUrl: devAppUrl,
  comparatorDocumentsUrl: devAppUrl + "/comparator/files/",
  appUrl: appUrl,
  loggedInUrl: appUrl + '/api/v1/utilizator',
  keycloakOptions,
  showbot: true,
  botUrl: 'https://posf-staging.anre.ro/',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
